import React, { useContext, useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { KeyboardReturnOutlined } from "@mui/icons-material";
import axios from "axios";
import AuthContext from "../../../context/userAuth.context";
import Swal from "sweetalert2";

export const SoundPlayer = (props) => {
  //const [time, settime] = useState();
  const [playing, setPlaying] = useState(false);
  const [pause, setPause] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [currentPlayingAudio, setCurrentPlayingAudio] = useState(null);

  const { Access, getLink } = useContext(AuthContext);

  useEffect(() => {
    // let audio = document.createElement("audio");
    // audio.id = props.value.path;
    // audio.src = props.authenticationData.ApiBaseURL + "/" + props.value.path;
    // //PlayAudio(audio,playing);
    // //var audio = document.getElementById('audio-1');
    // audio.onloadedmetadata = function () {
    //   var totalNumberOfSeconds = Math.round(audio.duration);
    //   var hours = parseInt(totalNumberOfSeconds / 3600);
    //   var minutes = parseInt((totalNumberOfSeconds - hours * 3600) / 60);
    //   var seconds = Math.floor(
    //     totalNumberOfSeconds - (hours * 3600 + minutes * 60)
    //   );
    //   let result =
    //     (minutes < 10 ? "0" + minutes : minutes) +
    //     ":" +
    //     (seconds < 10 ? "0" + seconds : seconds);
    //   settime(result);
    // };
  }, []);

  const PlayAudio = (path) => {
    if (!currentPlayingAudio) {
      var audio = new Audio(path);
      audio.id = path;
      setCurrentPlayingAudio(audio);
      audio.play();
    } else {
      currentPlayingAudio.src =
        props.authenticationData.ApiBaseURL + "/" + props.value.path;
      currentPlayingAudio.play();
    }
    //const toggle = (data) => setToggle(data);

    // useEffect(() => {
    //   playing ? audios.play() : audios.pause();
    // }, [playing]);

    // useEffect(() => {
    //   audios.addEventListener("ended", () => setPlaying(false));
    //   return () => {
    //     audios.removeEventListener("ended", () => setPlaying(false));
    //   };
    // }, []);
  };

  const PauseAudio = () => {
    if (currentPlayingAudio) {
      currentPlayingAudio.src = null;
      currentPlayingAudio.pause();
    }
  };

  useEffect(() => {
    PauseAudio();
  }, [pause]);

  var calculateSoundDuration = (url) =>
    new Promise((resolve, reject) => {
      let audio = document.createElement("audio");
      audio.id = url;
      audio.src = url;

      //var audio = document.getElementById('audio-1');
      audio.onloadedmetadata = function () {
        var totalNumberOfSeconds = Math.round(audio.duration);
        var hours = parseInt(totalNumberOfSeconds / 3600);
        var minutes = parseInt((totalNumberOfSeconds - hours * 3600) / 60);
        var seconds = Math.floor(
          totalNumberOfSeconds - (hours * 3600 + minutes * 60)
        );
        let result =
          (minutes < 10 ? "0" + minutes : minutes) +
          ":" +
          (seconds < 10 ? "0" + seconds : seconds);
        //settime(result);
        resolve(result);
      };
    });

  useEffect(() => {
    if (props.PlayerParent != null) {
      PlayAudio(props.value.path);
      if (props.PlayerParent != props.value.path) {
        if (playing) {
          setToggle(true);
        }
      }
    }
  }, [props.PlayerParent]);

  useEffect(() => {
    if (!props.playState) {
      if (playing) {
        toggle(false);
        //audio.currentTime = 0
      }
    }
  }, [props.playState]);

  return (
    <div id={props.value.id}>
      <div id={props.value.id} className="SoundPlayBtn">
        {!playing && (
          <span
            className="material-icons"
            style={{
              color: "white",
              fontSize: "14px",
            }}
            onClick={(e) => {
              if (Access == "FE" && props.value.isPremium) {
                Swal.fire({
                  title: "Upgrade Required",
                  html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                  icon: "info",
                  cancelButtonColor: "#d33",
                  backdrop: null,
                });
                return;
              }
              setPlaying(true);
              PlayAudio(
                props.authenticationData.ApiBaseURL + "/" + props.value.path
              );
              // if(playing)
              //   setPlaying(false);
              // else
              //   setPlaying(true);
              //props.setPlayerParent(props.authenticationData.ApiBaseURL + "/" + props.value.path);
            }}
          >
            play_arrow
          </span>
        )}

        {playing && (
          <span
            className="material-icons"
            style={{
              color: "white",
              fontSize: "14px",
            }}
            onClick={() => {
              //alert("")
              //props.setPlayerParent(props.authenticationData.ApiBaseURL + "/" + props.value.path);

              // if (playing)
              //   setPlaying(false);
              // if (pause)
              //   setPause(false);
              // else
              //   setPause(true);
              setPlaying(false);
              setToggle(false);
              PauseAudio();
            }}
          >
            pause
          </span>
        )}
      </div>
    </div>
  );
};

export default SoundPlayer;
